import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import AttachMoneyIcon from '@material-ui/icons/AttachMoney';
import PriceVatDisclaimer from 'common/PriceVatDisclaimer';


const INVERSION_TOTAL_USD = '80';
const RESERVA_USD = '30';
const TNO_URL = 'https://www.tnonetwork.com';

function openWhatsAppInversion() {
  const phoneNumber = '+584222020113';
  const message = `Hola, quiero inscribirme en Oratoria Estratégica en TNO. ¿Cuál es la inversión total ($${INVERSION_TOTAL_USD}) y cómo hago la reserva de $${RESERVA_USD}?`;
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
  window.open(whatsappUrl, '_blank', 'noopener,noreferrer');
}

const InversionFacilidades = () => {
  return (
    <Box py={{ xs: 2, md: 3 }}>
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 600 }}
        variant="overline"
        color="primary"
        align="center"
        display="block"
        gutterBottom
      >
        Inversión y facilidades
      </Typography>
      <Box component={Typography} fontWeight={900} variant="h4" gutterBottom align="center">
        Tu crecimiento no tiene precio, pero sí una oportunidad única
      </Box>
      <Typography
        variant="body1"
        align="center"
        color="textSecondary"
        sx={{ maxWidth: 920, mx: 'auto', mb: 3 }}
      >
        Inversión total: <strong>${INVERSION_TOTAL_USD}</strong> (BCV). Reserva hoy: aparta tu lugar con solo{' '}
        <strong>${RESERVA_USD}</strong> y paga el resto hasta un día antes de iniciar.
      </Typography>

      <Grid container spacing={2} alignItems="stretch">
        <Grid item xs={12} md={5}>
          <Paper
            elevation={0}
            sx={{
              height: '100%',
              p: 2.5,
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Box display="flex" alignItems="center" gap={1.5} mb={1}>
              <AttachMoneyIcon color="primary" />
              <Typography variant="h6" sx={{ fontWeight: 900 }}>
                Reserva y cupo
              </Typography>
            </Box>
            <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
              Los cupos son limitados para asegurar práctica y feedback en cada sesión.
            </Typography>
            <Button
              fullWidth
              variant="contained"
              color="primary"
              size="large"
              onClick={openWhatsAppInversion}
            >
              Reservar por WhatsApp
            </Button>
          </Paper>
        </Grid>

        <Grid item xs={12} md={7}>
          <Paper
            elevation={0}
            sx={{
              height: '100%',
              p: 2.5,
              borderRadius: 3,
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 900, mb: 1 }}>
              Tu inscripción incluye
            </Typography>
            <List disablePadding>
              <ListItem disableGutters>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <CheckCircleIcon color="primary" />
                </ListItemIcon>
                <ListItemText
                  primary={
                    <span>
                      Acceso exclusivo a los estudios de{' '}
                      <a href={TNO_URL} target="_blank" rel="noopener noreferrer">
                        TNO Network
                      </a>
                      .
                    </span>
                  }
                />
              </ListItem>
              <ListItem disableGutters>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <CheckCircleIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="Material de apoyo estratégico y guía de ejercicios." />
              </ListItem>
              <ListItem disableGutters>
                <ListItemIcon sx={{ minWidth: 36 }}>
                  <CheckCircleIcon color="primary" />
                </ListItemIcon>
                <ListItemText primary="Certificado de asistencia y aprobación." />
              </ListItem>
            </List>
          </Paper>
        </Grid>
      </Grid>
      <PriceVatDisclaimer />
    </Box>
  );
};

export default InversionFacilidades;

